


























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { Device, Info, User, ApiKey } from '@/types/core';
import { DateTime } from 'luxon';
import { curCoreClient, CoreClient } from '@/services/CoreClient';

import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import ConfirmedAction from '@/components/ConfirmedAction.vue';
import SectionHeader from '@/components/SectionHeader.vue';

@Component({
  components: {
    VueError,
    Success,
    ConfirmedAction,
    SectionHeader
  },
})
export default class UnenrolDevice extends Vue {

  @Prop({ default: {},  type: Object}) device!: Device;

  error:string = '';
  success:string = '';

  private coreClient:CoreClient = curCoreClient;
  
  
  async unenrolDevice() {

    const reply = await this.coreClient.unenrolDevice({deviceId: this.device.deviceId});
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to unenrol device: ${reply.errorMsg}`;
    
    this.setSuccess(`Device ${this.device.deviceId} has been unenrolled`);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('close'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
